import { render, staticRenderFns } from "./defineInput.vue?vue&type=template&id=72dc342c&scoped=true&"
import script from "./defineInput.vue?vue&type=script&lang=js&"
export * from "./defineInput.vue?vue&type=script&lang=js&"
import style0 from "./defineInput.vue?vue&type=style&index=0&id=72dc342c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc342c",
  null
  
)

export default component.exports